import { components } from "react-select";

const SelectSingleValueVehicle = (props: any) => {
    const { label, value } = props.data;

    return (
        <components.SingleValue {...props}>
            <span>{`${label} - `}</span>
            <span style={{ color: "gray" }}>{value.toUpperCase()}</span>
        </components.SingleValue>
    );
};

export default SelectSingleValueVehicle;
